import { render, staticRenderFns } from "./ListSimple.vue?vue&type=template&id=08775e6a&scoped=true"
import script from "./ListSimple.vue?vue&type=script&lang=js"
export * from "./ListSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08775e6a",
  null
  
)

export default component.exports